import {
  CLEAR_ACTIVE_AIRCRAFT,
  SET_ACTIVE_AIRCRAFT,
  SET_AIRCRAFT_FILTERS,
  UPDATE_ACTIVE_AIRCRAFT,
  UPDATE_AIRCRAFT_MAP,
  UPDATE_AIRCRAFT_LIST,
} from 'actions';

export function activeAircraft(state = {}, action) {
  switch (action.type) {
    case SET_ACTIVE_AIRCRAFT:
    case UPDATE_ACTIVE_AIRCRAFT:
      return action.activeAircraft;
    case CLEAR_ACTIVE_AIRCRAFT:
      return null;
    default:
      return state;
  }
}

export function aircraftFilters(state = {}, action) {
  switch (action.type) {
    case SET_AIRCRAFT_FILTERS:
      return action.aircraftFilters;
    default:
      return state;
  }
}

export function aircraftMap(state = [], action) {
  switch (action.type) {
    case UPDATE_AIRCRAFT_MAP:
      const { aircraftMap } = action;

      // if state is already populated and the new list has no entries
      if (state && aircraftMap.length < 1) {
        return state;
      }

      const newState = state && state instanceof Map ? state : new Map();

      aircraftMap.forEach((updateAircraft, aircraftId) => {
        if (newState.has(updateAircraft.id)) {
          // aircraft is in list
          // if the aircraft has not been deleted
          if (!updateAircraft.deleted) {
            newState.set(aircraftId, updateAircraft);
          } else {
            // remove the aircraft from new state
            newState.delete(aircraftId);
          }
          // aircraft is not in list and is not deleted
        } else if (!updateAircraft.deleted) {
          // add updateAircraft to newState
          newState.set(aircraftId, updateAircraft);
        }
      });

      return newState;
    default:
      return state;
  }
}

export function aircraftList(state = [], action) {
  switch (action.type) {
    case UPDATE_AIRCRAFT_LIST:
      return action.aircraftList;
    default:
      return state;
  }
}
